import {Component, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from 'ngx-alerts';
import {DashboardService} from '../../../../services/dashboard.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-vehicle-trouble-codes',
  templateUrl: './vehicle-trouble-codes.component.html',
  styleUrls: ['./vehicle-trouble-codes.component.scss']
})
export class VehicleTroubleCodesComponent implements OnInit {
  vehicleAlerts: any[] = [];
  name: string = '';
  search = {
    isActiveAlerts: true,
    size: 10,
    page: 0
  };

  totalRecords = 0;
  pageEvent: PageEvent;
  vehicleId: any;

  constructor(private router: Router, private route: ActivatedRoute, private alertService: AlertService,
              public dashboardService: DashboardService, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    let queryParams = this.route.snapshot.queryParams;
    this.name = queryParams['name'];
    let params = this.route.snapshot.params;
    this.vehicleId = params['vehicleId'];
    this.getVehicleTroubleCodes();
  }

  private getVehicleTroubleCodes() {
    this.dashboardService.getVehicleAlerts(this.vehicleId, this.search).subscribe(
      (res: any) => {
        this.totalRecords = res.totalRecords;
        this.vehicleAlerts = res.alerts;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }


  getServerData(ev: PageEvent) {
    this.search.page = ev.pageIndex;
    this.search.size = ev.pageSize;
    this.getVehicleTroubleCodes();
    return ev;
  }
}
